<div class="text-center" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="32px">
  <section fxLayout fxLayoutAlign="start center" fxLayoutGap="9px">
    <div class="success-separator"></div>

    <svg width="50" height="50" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.8334 12.0035V13.0002C23.8321 15.3363 23.0756 17.6094 21.6769 19.4805C20.2781 21.3516 18.312 22.7204 16.0717 23.3827C13.8315 24.0451 11.4371 23.9656 9.24576 23.156C7.0544 22.3464 5.18346 20.8501 3.91196 18.8903C2.64045 16.9305 2.03652 14.6122 2.19023 12.2812C2.34394 9.95012 3.24706 7.7312 4.76488 5.95534C6.28271 4.17948 8.33393 2.94184 10.6126 2.427C12.8913 1.91216 15.2754 2.14771 17.4093 3.09851"
        stroke="#47C693"
        stroke-width="1.95"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M23.8333 4.3335L13 15.1777L9.75 11.9277"
        stroke="#47C693"
        stroke-width="1.95"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  </section>

  <section fxLayout="column" fxLayoutGap="20px">
    <h2>That's it!</h2>
    <span>You're done.</span>
  </section>

  <section style="width: 100%">
    <button
      data-intercom-target="direct-tax-done"
      mat-flat-button
      [routerLink]="['/settings/taxes']"
      [ngClass.lt-md]="{ fw: true }">
      View Taxes
    </button>
  </section>
</div>
